import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "The Atelier", href: "#manifesto", testid: "nav-link-atelier" },
  { label: "Lessons", href: "#services", testid: "nav-link-services" },
  { label: "Cécile", href: "#cecile", testid: "nav-link-cecile" },
  { label: "Testimonials", href: "#temoignages", testid: "nav-link-testimonials" },
  { label: "Formats", href: "#formules", testid: "nav-link-formats" },
];

export default function Nav({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const go = (href) => {
    setOpen(false);
    onNavigate(href);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-xl border-b border-sand" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <button
          onClick={() => go("#top")}
          className="font-serif text-xl tracking-wide"
          data-testid="nav-logo"
        >
          The French Atelier <span className="italic text-gold">by Cécile</span>
        </button>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => go(l.href)}
              className="link-underline text-sm text-navy/80 hover:text-navy transition-colors"
              data-testid={l.testid}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("#contact")}
            className="btn-fill border border-navy px-6 py-2 text-sm tracking-wide"
            data-testid="nav-cta-book"
          >
            Book a lesson
          </button>
        </nav>
        <button
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="nav-mobile-menu-button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden border-t border-sand bg-cream"
            data-testid="nav-mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <button
                  key={l.href}
                  onClick={() => go(l.href)}
                  className="text-left font-serif text-2xl"
                  data-testid={`${l.testid}-mobile`}
                >
                  {l.label}
                </button>
              ))}
              <button
                onClick={() => go("#contact")}
                className="mt-2 border border-navy px-6 py-3 text-sm tracking-wide text-left"
                data-testid="nav-cta-book-mobile"
              >
                Book a lesson
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
